/**
 * Translate description: Index page for stores
 */

import { useEffect, useContext } from 'react';

import { langByCode, useLanguageContext } from "../../context/LanguageContext";
import AppContext from '../../context/AppContext';
import InfoContext from '../../context/InfoContext';
import AppProvider from '../../provider/AppProvider';

import Bread from '../../components/layout/BreadCrumbs';
import Title from '../../components/layout/Title';
import ModalDelete from '../../components/layout/ModalDelete';
import { AddButton } from '../../components/blocks/AddButton';
import Content from './components/Content';

import Typography from '@mui/joy/Typography';

import { Crud } from '../../utils/crud';

const crud = new Crud('stores');

const fetchOffers = async (ids) => {
  return (await crud.query('offerscnt', 'post', { ids })).data;
}

function _Index() {
  const { t } = useLanguageContext();

  const { setInfo } = useContext(InfoContext);
  const { setListItems } = useContext(AppContext);
  const { paginator, setPaginator } = useContext(AppContext);
  const { sorting } = useContext(AppContext);
  const { filter, setFilter } = useContext(AppContext);
  const { setLoading } = useContext(AppContext);
  const { currentLang } = useContext(AppContext);

  useEffect(() => {
    if (currentLang) {
      setFilter({ ...filter, lang: { id: langByCode(currentLang).id } })
    }
  }, [currentLang]);

  useEffect(() => {
    const loadTable = async () => {
      if (!filter?.lang) return;
      setLoading(true);

      let list = await crud.get({ paginator, sorting, filter })
      if (list.is_error) {
        setInfo({ type: 'danger', show: true, message: `${t('Error')}` });
        setTimeout(() => setInfo({ show: false }), 6000)
        setLoading(false);
        return;
      }
      // setListItems(list.data);
      let store_ids = list.data.map(v => v.id);
      if (store_ids?.length) {
        let _data = await fetchOffers(store_ids);
        for (const el of list.data) {
          const info = _data.find(v => v.store_id === el.id);
          el.offcnt = { active: info?.active_offers || 0, inactive: info?.inactive_offers || 0 }
        }
      }
      setListItems(list.data);
      setLoading(false);
      setPaginator({ ...paginator, totalPages: list.pages });
    }
    loadTable();
  }, [paginator.currentPage, filter.lang?.id, filter.lang?.operator, filter.status?.id, filter.name?.value, sorting]);


  return (
    <>
      <Bread path={[{ name: t("Stores") }]} />
      <Title>
        <Typography level="h2" component="h1">{t("Stores")}</Typography>
        <AddButton label={t("New store")} to={`/stores/add/${currentLang}`} />
      </Title>
      <Content />
      <ModalDelete />
    </ >
  );
}

export default function Index() {
  return (
    <AppProvider>
      <_Index />
    </AppProvider>
  );
}